module.exports = __webpack_public_path__ + "static/media/login_image_2.52266fe0.png";